import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ModalService } from '@cfp/core';
import { Link } from '@cfp/ui';
import { Alert, InfoModal } from '@cfp/ui/feedback';
import { TranslateModule } from '@ngx-translate/core';

const ROADMAP_TABLE_SHOW_PROPERTY_NAME = 'dont-show-roadmap-measure-relation-alert';

@Component({
  selector: 'cfp-roadmap-measure-relation-alert',
  templateUrl: './roadmap-measure-relation-alert.html',
  imports: [TranslateModule, Alert, Link],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoadmapMeasureRelationAlert {
  protected showAlert = signal<boolean>(true);

  private readonly modalService = inject(ModalService);

  constructor() {
    this.showAlert.set(localStorage.getItem(ROADMAP_TABLE_SHOW_PROPERTY_NAME) !== '1');
  }

  protected dismiss(): void {
    localStorage.setItem(ROADMAP_TABLE_SHOW_PROPERTY_NAME, '1');
    this.showAlert.set(false);
  }

  protected showMeasureRelationAlertModal(): void {
    this.modalService.show(InfoModal, {
      initialState: {
        title: 'roadmap.measureRelationAlert.modalTitle',
        body: 'roadmap.measureRelationAlert.modalBody'
      }
    });
  }
}
